import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import Comment from './comment-model'
import {
  CreateCommentAsync,
  DeleteCommentAsync,
  LoadCommentsAsync,
} from './comment-thunk'
const initialState: commentSliceState = {
  comment: [],
  selected_comment: '',
  is_loading_comment: false,
  is_creating_comment: false,
  is_deleting_comment: false,
}
export interface commentSliceState {
  comment: Comment[]
  selected_comment?: string
  is_loading_comment: boolean
  is_creating_comment: boolean
  is_deleting_comment: boolean
}
export const commentSlice = createSlice({
  name: 'comment',
  initialState,
  reducers: {
    setSelectedcomment: (state, action) => {
      state.selected_comment = action.payload
    },
    clearStatecomment: (state) => {
      state.comment = []
      state.is_loading_comment = false
      state.is_creating_comment = false
      state.is_deleting_comment = false
    },
    mergecomment: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_comment = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.comment = merge(state.comment, payload) as any
        }
      }
    },

    add_comment: (state, action) => {
      if (action.payload) {
        state.comment = [...state.comment, action.payload]
      }
    },
    set_comment: (state, action) => {
      let { key, value, id } = action.payload
      state.comment = state.comment.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadCommentsAsync.pending, (state) => {
      state.is_loading_comment = true
    })
    builder.addCase(LoadCommentsAsync.fulfilled, (state, action) => {
      state.is_loading_comment = false
      if (action.payload) {
        state.comment = action.payload
      }
    })
    builder.addCase(LoadCommentsAsync.rejected, (state) => {
      state.is_loading_comment = false
    })
    builder.addCase(CreateCommentAsync.pending, (state) => {
      state.is_creating_comment = true
    })
    builder.addCase(CreateCommentAsync.fulfilled, (state) => {
      state.is_creating_comment = false
    })
    builder.addCase(CreateCommentAsync.rejected, (state) => {
      state.is_creating_comment = false
    })
    builder.addCase(DeleteCommentAsync.pending, (state) => {
      state.is_deleting_comment = true
    })
    builder.addCase(DeleteCommentAsync.fulfilled, (state, action) => {
      state.is_deleting_comment = false
      if (state.comment) {
        state.comment = state.comment.filter((x) => action.payload.id !== x.id)
      }
    })
    builder.addCase(DeleteCommentAsync.rejected, (state) => {
      state.is_deleting_comment = false
    })
  },
})

export const {
  clearStatecomment,
  setSelectedcomment,
  set_comment,
  mergecomment,
  add_comment,
} = commentSlice.actions

export const get_comment =
  (id?: string) =>
  (state: {
    comment: {
      comment: Comment[]
    }
  }): Comment | null => {
    let temp = state?.comment?.comment?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.comment?.comment[0] || null
  }
export const get_selected_comment = (state: {
  comment: commentSliceState
}): Comment | null => {
  let id = state?.comment?.selected_comment
  let temp = state?.comment?.comment?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_comment = (state: {
  comment: {
    comment: Comment[]
  }
}): Comment[] => {
  let temp = state?.comment?.comment
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_comment_busy = (state: { comment: commentSliceState }) => {
  return (
    state?.comment.is_deleting_comment ||
    state?.comment.is_loading_comment ||
    state?.comment.is_creating_comment
  )
}
export const is_deleting_comment_busy = (state: {
  comment: commentSliceState
}) => {
  return state?.comment.is_deleting_comment
}
export const is_loading_comment_busy = (state: {
  comment: commentSliceState
}) => {
  return state?.comment.is_loading_comment
}
export const is_creating_comment_busy = (state: {
  comment: commentSliceState
}) => {
  return state?.comment.is_creating_comment
}

export default commentSlice.reducer
